import React from "react";
import { Button } from "@showitinc/showit-wc";
import PropTypes from "prop-types";
import _ from "lodash";
import cx from "classnames";
import { showDomainSetupModal } from "../../adaptors/ModalAdaptors";
import DomainListRow from "./DomainListRow";
import SubdomainNameUpdateForm from "./SubdomainNameUpdateForm";
import SubviewProcessing from "../SubviewProcessing";
import uiPrefix from "../../utils/UiPrefixUtils";

const TAB_ENABLED = "enabled";
const TAB_DISABLED = "disabled";

class SelectDomainView extends React.Component {
  static propTypes = {
    domains: PropTypes.array,
    domainsLoaded: PropTypes.bool,
    domainsLoading: PropTypes.bool,
    domainsError: PropTypes.bool,
    activeTab: PropTypes.string,
    addSubdomainEnabled: PropTypes.bool,
    subdomainSaving: PropTypes.bool,
    subdomainAddError: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),

    selectDomain: PropTypes.func,
    addSubdomain: PropTypes.func,
    updateView: PropTypes.func,
  };

  static defaultProps = {
    domains: [],
  };

  _selectDomain = (domain) => {
    this.props.selectDomain(domain);
  };

  _selectTab = (tab) => {
    this.props.updateView(this.props.name, { activeTab: tab });
  };

  _toggleAdd = (value) => {
    this.props.updateView(this.props.name, { addSubdomainEnabled: value });
  };

  _addNewSubdomain = (data) => {
    if (this.props.addSubdomain) {
      this.props.addSubdomain(data);
    }
  };

  _openDomainSetup = showDomainSetupModal;

  _getDomainTableSubview = (domains, primaryDomain) => {
    const disabledVal = this.props.activeTab == TAB_ENABLED ? 0 : 1;

    const filterDomains = _.filter(domains, { disabled: disabledVal });

    const rows = _.map(
      filterDomains,
      _.bind(function (domain, index) {
        return (
          <DomainListRow
            key={domain.site_id}
            domain={domain}
            index={index}
            onClick={this._selectDomain.bind(this, domain)}
          />
        );
      }, this)
    );

    const tabStyle = {
      width: 110,
      flexGrow: 0,
    };

    const enabledTab = cx({
      tab: true,
      [uiPrefix("enabled-tab")]: true,
      active: this.props.activeTab === TAB_ENABLED,
    });

    const disabledTab = cx({
      tab: true,
      [uiPrefix("disabled-tab")]: true,
      active: this.props.activeTab === TAB_DISABLED,
    });

    const footer = this._getTableFooter(primaryDomain);

    return (
      <div
        className="view-centered"
        style={{ padding: "8px 16px", flexDirection: "column", justifyContent: "flex-start" }}
      >
        <div className="properties-tabset-wrapper" style={{ width: "100%" }}>
          <div
            className="properties-tabset"
            style={{ marginBottom: 0, boxShadow: "rgba(255,255,255,0.1) 0 -1px 0 inset" }}
          >
            <div
              data-e2e={uiPrefix("enabled-tab")}
              className={enabledTab}
              style={tabStyle}
              onClick={this._selectTab.bind(this, TAB_ENABLED)}
            >
              Enabled
            </div>
            <div
              data-e2e={uiPrefix("disabled-tab")}
              className={disabledTab}
              style={tabStyle}
              onClick={this._selectTab.bind(this, TAB_DISABLED)}
            >
              Disabled
            </div>
          </div>
          <div className="si-table" style={{ height: 344, overflow: "auto" }}>
            {rows}
          </div>
        </div>
        {footer}
      </div>
    );
  };

  _getTableFooter = (primaryDomain) => {
    let view = null;

    if (this.props.addSubdomainEnabled) {
      view = (
        <SubdomainNameUpdateForm
          primaryDomain={primaryDomain}
          onCancel={this._toggleAdd.bind(this, false)}
          onNameUpdate={this._addNewSubdomain}
          submitting={this.props.subdomainSaving}
          error={this.props.subdomainAddError}
        />
      );
    } else {
      view = (
        <Button variant="feature" onClick={this._toggleAdd.bind(this, true)}>
          Add New +Site Domain
        </Button>
      );
    }

    return <div style={{ padding: 16 }}>{view}</div>;
  };

  _getDomainSetupSubview = () => (
    <div className="view-centered" style={{ flexDirection: "column" }}>
      <div style={{ fontSize: 24, padding: 20 }}>Need To Add A Domain. No Problem.</div>
      <Button variant="feature" onClick={this._openDomainSetup}>
        Click Here To Get Started
      </Button>
    </div>
  );

  render() {
    const domainsLoading = this.props.domainsLoading;
    const domainsLoaded = this.props.domainsLoaded;
    const domains = this.props.domains;
    let subview = null;

    if (domainsLoaded) {
      const primaryDomain = _.find(domains, { parent_site_id: null });

      if (_.isEmpty(primaryDomain)) {
        subview = this._getDomainSetupSubview();
      } else {
        subview = this._getDomainTableSubview(domains, primaryDomain);
      }
    } else if (this.props.domainsError) {
      subview = (
        <div style={{ padding: 20, textAlign: "center" }}>
          Your domains could not be loaded. Close this window and try again.
        </div>
      );
    } else {
      subview = <SubviewProcessing message="Your Domains Are Loading" />;
    }

    return <div>{subview}</div>;
  }
}

export default SelectDomainView;
